<template>
  <v-card outlined class="pa-3">
    <div v-if="progress">
      <div class="subtitle-1 font-weight-bold mb-2">User Progress</div>

      <v-row dense>
        <v-col cols="6">
          <div class="caption grey--text">Completion Rate</div>
          <v-progress-linear
            :value="progress.completion_rate"
            color="green"
            height="20"
            rounded
          >
            <template v-slot:default>
              <strong class="white--text"
                >{{ progress.completion_rate }}%</strong
              >
            </template>
          </v-progress-linear>
        </v-col>
        <v-col cols="6">
          <div class="caption grey--text">Current Streak</div>
          <div class="text-h5 font-weight-bold orange--text">
            {{ progress.streak }} day{{ progress.streak !== 1 ? "s" : "" }}
          </div>
        </v-col>
      </v-row>

      <v-row dense class="mt-2">
        <v-col cols="6">
          <div class="caption grey--text">This Week</div>
          <div>
            <span class="font-weight-bold green--text">{{
              progress.week_completed
            }}</span>
            / {{ progress.week_total }} completed
          </div>
        </v-col>
        <v-col cols="6">
          <div class="caption grey--text">This Month</div>
          <div>
            <span class="font-weight-bold green--text">{{
              progress.month_completed
            }}</span>
            / {{ progress.month_total }} completed
          </div>
        </v-col>
      </v-row>

      <div v-if="progress.overdue > 0" class="mt-2">
        <v-alert type="error" dense outlined>
          {{ progress.overdue }} overdue task(s)
        </v-alert>
      </div>
    </div>
    <div v-else class="text-center grey--text pa-4">
      Select a user to view progress
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    progress: { type: Object, default: null },
  },
};
</script>
